import type { TenantConfig } from '@/types/TenantConfig'

const red = '#DE504B'
const lightRed = '#E4847A'
const pink = '#EFC4C7'

export const peppermintparkway: TenantConfig = {
  logo: 'assets/peppermintparkway/static/logo.png',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: red,
    secondaryColor: pink,
    logoHeight: '90px',
    headerHeight: '110px',
    headerBackground: pink,
    memberLinksColor: red,
    cartHeaderBackgroundColor: pink,
    cartHeaderTextColor: red,
    footerBackgroundColor: red,
    footerTextColor: 'white',
    mobileFooter: {
      textColor: red,
      cartBadgeBackgroundColor: red,
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/peppermintparkway/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-180px',
        mobile: '-110px',
      },
    },
  },
}
